import { fetchABTest } from '../apis/home'

export function getABTest() {
  if (window.abtestGetted) {
    return Promise.resolve()
  } else {
    window.abtest = {}
    return fetchABTest()
      .then(res => {
        if (res && res.data) {
          const result = res.data
          if (result.code === 0) {
            // 放到window.abtest下，report自动获取上报
            window.abtest = result.data
          }
        }
      })
      .finally(() => {
        window.abtestGetted = true
        return Promise.resolve()
      })
  }
}